
import React from 'react';
import {Times} from "../../funcs/utils";

const DIALOG_STYLE = {
  border: "solid 1px #000",
  padding: "0.5rem",
  width: "30rem",
  background: "#FFF",
  zIndex: "10",
}

const ERRORS = {
  TOO_SMALL: "Amount is too small, must be multiple of 1000",
  MULTIPLE_1000: "Amount must be multiple of $1000",
  NOT_ENOUGH_CASH: "Amount is greater than available cash",
}

const HEADER_SORT = {
  INCR: "INCR",
  DECR: "DECR",
}

const render_header = (item, component) => {
  const on_close = () => {
    component.onHidePurchaseModal();
  }
  return (
    <div style={{display: "flex"}}>
      <div>
        Purchase: { item.CUSIP }
      </div>
      <div style={{ flex: "1"}}/>
      <div onClick={on_close}>
        <Times/>
      </div>
    </div>
  );
}

const dump_input = (component, prm, style={}) => {

  const input_style = {
    textAlign: "center",
    width: "100%",
    ...style,
  }

  const on_click = () => {
    component.setState({
      blank_firm_name: false,
      blank_amt: false,
      blank_last_name: false,
    })
  }
  const on_change = ev => {
    const new_value = ev.target.value;
    component.setState({
      [prm]: new_value,
      dialog_error: "",
      blank_firm_name: false,
      blank_amt: false,
      blank_last_name: false,
    })
  }
  return (
    <input
      value={component.state[prm]}
      onClick={on_click}
      onChange={on_change}
      style={input_style}/>
  );
}

const dump_pair = (left, right, style={}) => {
  const container_style = {
    ...style,
    display: "flex",
  }
  return (
    <div style={container_style}>
      <div style={{flex: "1"}}>
        { left }
      </div>
      <div style={{width: "1rem"}}/>
      <div style={{flex: "1"}}>
        {right}
      </div>
    </div>
  );
}

const render_amt_input = component => {
  const error = component.state.dialog_error;
  const error_style = {
    color: "#F00",
    fontWeight: "bold"
  }
  const input_style = {};
  if (component.state.blank_amt) {
    input_style.border = "2px solid red";
  }
  return dump_pair(
    (<div style={{flex: "1"}}>
      How many CDs do you need?
      <br/>(In dollar amount)
    </div>),
    (
        <div>
          <div style={{display: "flex"}}>
            <div align={"center"} style={{width: "1.5rem"}}>$</div>
            <div style={{flex: "1"}}>
              {dump_input(component, "purchase_amt", input_style)}
            </div>
          </div>
          <div align={"center"} style={error_style}>
            {error}
          </div>
        </div>
    ));
}

const parse_amt = amt_str => {
  if (!amt_str || amt_str === "") {
    return 0.;
  }

  return parseFloat(amt_str.replace('$', '').replace(',', ''));
}

const mult_of_1000 = amt_usd => {
  return amt_usd / 1000. === Math.floor(amt_usd / 1000.);
}

export { DIALOG_STYLE, ERRORS, HEADER_SORT, render_header,
  render_amt_input, dump_input, dump_pair, parse_amt, mult_of_1000 };
